var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooth-remove-mode-item",attrs:{"id":"toothRemoveControls"}},[_c('div',{style:({ color: _vm.mode.isWhite ? _vm.mode.blueColor : _vm.mode.whiteColor }),attrs:{"id":"toothRemoveHint"}},[_vm._v("Click tooth to remove")])])}
var staticRenderFns = []

export { render, staticRenderFns }